import React from "react";
import { motion } from "framer-motion";
import { Award, GraduationCap, Trophy, Users, Briefcase } from "lucide-react";
import { DOCTOR, TEAM_DOCTORS } from "@/data/static";

export default function About() {
  return (
    <main className="pt-32 pb-16" data-testid="about-page">
      <div className="container-x">
        <motion.div initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.6}}>
          <span className="overline">About</span>
          <h1 className="font-heading text-5xl sm:text-6xl tracking-tight font-light mt-3">Meet <em className="italic font-medium text-primary">{DOCTOR.name}</em></h1>
          <p className="mt-4 text-lg text-slate-600 max-w-3xl">{DOCTOR.title} with {DOCTOR.experience} of clinical excellence.</p>
        </motion.div>

        <div className="mt-12 grid lg:grid-cols-3 gap-10">
          <div className="relative">
            <img src={DOCTOR.photo} alt={DOCTOR.name} className="rounded-3xl shadow-medium w-full h-[560px] object-cover"/>
          </div>
          <div className="lg:col-span-2 space-y-10">
            <div>
              <h2 className="font-heading text-2xl font-medium text-primary">Biography</h2>
              <p className="mt-4 text-slate-700 leading-relaxed">{DOCTOR.bio}</p>
            </div>
            <div className="grid sm:grid-cols-2 gap-5">
              {[
                {icon:GraduationCap,title:"Qualifications",items:DOCTOR.degrees},
                {icon:Trophy,title:"Awards",items:DOCTOR.awards},
                {icon:Users,title:"Memberships",items:DOCTOR.memberships},
                {icon:Award,title:"Languages Spoken",items:DOCTOR.languages.map(l=>l)},
              ].map((s,i)=>{
                const Icon = s.icon;
                return (
                  <div key={i} className="bg-white rounded-2xl border border-slate-100 p-6 shadow-soft">
                    <div className="flex items-center gap-3"><Icon className="w-5 h-5 text-primary"/><div className="font-heading font-medium">{s.title}</div></div>
                    <ul className="mt-3 space-y-1.5 text-sm text-slate-600">
                      {s.items.map((it,j)=>(<li key={j} className="flex gap-2"><span className="text-primary mt-1">·</span>{it}</li>))}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="mt-20">
          <span className="overline">Meet Our Doctors</span>
          <h2 className="font-heading text-4xl sm:text-5xl tracking-tight font-light mt-3">Specialists at <em className="italic font-medium text-primary">Aastha</em></h2>
          <div className="mt-10 grid md:grid-cols-3 gap-6">
            {TEAM_DOCTORS.map((d,i)=>(
              <motion.div key={d.id} initial={{opacity:0,y:20}} whileInView={{opacity:1,y:0}} viewport={{once:true,margin:"-60px"}} transition={{duration:0.5,delay:i*0.06}}
                className="group bg-white rounded-3xl overflow-hidden border border-slate-100 shadow-soft hover:shadow-medium transition-shadow"
                data-testid={`about-team-${d.id}`}>
                <div className="aspect-[4/5] overflow-hidden bg-slate-100">
                  <img src={d.photo} alt={d.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
                </div>
                <div className="p-6">
                  <div className="font-heading text-xl font-medium text-slate-900">{d.name}</div>
                  <div className="text-sm text-primary mt-1">{d.role}</div>
                  <div className="mt-4 space-y-2 text-sm text-slate-600">
                    <div className="flex gap-2"><GraduationCap className="w-4 h-4 text-primary mt-0.5 shrink-0"/><span>{d.qualifications}</span></div>
                    <div className="flex gap-2"><Briefcase className="w-4 h-4 text-primary mt-0.5 shrink-0"/><span>{d.experience}</span></div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}
